module.exports = __webpack_public_path__ + "static/media/received.3b71a5ed.svg";